import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { referralCodeFromSearch, rememberReferralCode } from "../utils/referralCode";
import { trackReferralLinkOpen } from "../utils/analytics";

/**
 * Picks up ?ref=CODE on whatever page a shared link opens and keeps it until
 * the shopper creates an account. Mounted once in App (inside the Router).
 */
export default function useReferralCapture() {
  const location = useLocation();
  useEffect(() => {
    if (!new URLSearchParams(location.search).has("ref")) return;
    const code = referralCodeFromSearch(location.search);
    if (code) rememberReferralCode(code);
    trackReferralLinkOpen(Boolean(code));
  }, [location.search]);
}
